export const getFullname = (skier) => {
    return skier?.firstname ? `${skier.firstname} ${skier.lastname}` : '';
}